import { gql } from "@apollo/client";

export const CREATE_BILLING_COUPON = gql`
  mutation createBillingCoupon(
    $companyID: [String!]
    $name: String!
    $promoCode: String!
    $oneUsePerCompany: Boolean!
    $oneUsePerUser: Boolean!
    $startDate: Float!
    $endDate: Float
    $value: Float!
    $unit: PromoValueUnit!
    $eventId: String
  ) {
    createBillingCoupon(
      data: {
        companyID: $companyID
        name: $name
        promoCode: $promoCode
        oneUsePerCompany: $oneUsePerCompany
        oneUsePerUser: $oneUsePerUser
        startDate: $startDate
        endDate: $endDate
        value: $value
        unit: $unit
        eventId: $eventId
      }
    )
  }
`;

export const UPDATE_BILLING_COUPON = gql`
  mutation updateBillingCoupon(
    $id: String!
    $companyID: [String!]
    $name: String
    $promoCode: String
    $oneUsePerCompany: Boolean
    $oneUsePerUser: Boolean
    $startDate: Float
    $endDate: Float
    $value: Float
    $unit: PromoValueUnit
    $eventId: String
  ) {
    updateBillingCoupon(
      data: {
        id: $id
        companyID: $companyID
        name: $name
        promoCode: $promoCode
        oneUsePerCompany: $oneUsePerCompany
        oneUsePerUser: $oneUsePerUser
        startDate: $startDate
        endDate: $endDate
        value: $value
        unit: $unit
        eventId: $eventId
      }
    )
  }
`;

export const DELETE_BILLING_COUPON = gql`
  mutation deleteBillingCoupon($couponId: String!) {
    deleteBillingCoupon(couponId: $couponId)
  }
`;

export const CREATE_PRODUCT_SIZE = gql`
  mutation CreateProductSize($input: CreateProductSizeInput!) {
    createProductSize(input: $input) {
      id
    }
  }
`;

export const UPDATE_PRODUCT_SIZE = gql`
  mutation UpdateProductSize($id: ID!, $input: UpdateProductSizeInput!) {
    updateProductSize(id: $id, input: $input) {
      id
    }
  }
`;

// UPDATE_EVENT_SETTINGS mutation
export const UPDATE_EVENT_SETTINGS = gql`
  mutation updateEvent(
    $id: String!
    $name: String!
    $name_check: Boolean
    $description: String
    $description_check: Boolean
    $startAt: DateTime
    $endAt: DateTime
    $platformEventTheme: PlatformEventThemeInput
    $timezone: String
    $timezoneLocation: String
    $location: String
    $location_check: Boolean
    $qr_code_url: String
    $qr_code_url_check: Boolean
    $privacy: String
    $privacy_check: Boolean
    $legal: String
    $legal_check: Boolean
    $contact_us: String
    $contact_us_check: Boolean
    $your_data: String
    $your_data_check: Boolean
    $logo_image_check: Boolean
    $header_image: String
    $header_image_check: Boolean
    $left_image: String
    $left_image_check: Boolean
    $right_image: String
    $right_image_check: Boolean
    $mobile_image: String
    $mobile_image_check: Boolean
    $menus: [PlatformEventMenuSettings!]
  ) {
    updateEvent(
      data: {
        id: $id
        eventType: PLATFORM_EVENT
        name: $name
        name_check: $name_check
        description: $description
        description_check: $description_check
        startAt: $startAt
        endAt: $endAt
        platformEventTheme: $platformEventTheme
        timezone: $timezone
        timezoneLocation: $timezoneLocation
        location: $location
        location_check: $location_check
        qr_code_url: $qr_code_url
        qr_code_url_check: $qr_code_url_check
        privacy: $privacy
        privacy_check: $privacy_check
        legal: $legal
        legal_check: $legal_check
        contact_us: $contact_us
        contact_us_check: $contact_us_check
        your_data: $your_data
        your_data_check: $your_data_check
        logo_image_check: $logo_image_check
        header_image: $header_image
        header_image_check: $header_image_check
        left_image: $left_image
        left_image_check: $left_image_check
        right_image: $right_image
        right_image_check: $right_image_check
        mobile_image: $mobile_image
        mobile_image_check: $mobile_image_check
        menus: $menus
      }
    )
  }
`;

export const CREATE_TEAM = gql`
  mutation CreateTeam($data: CreateTeamInput!) {
    createTeam(data: $data)
  }
`;

export const CREATE_EVENT_CLUSTER = gql`
  mutation createEventCluster(
    $eventId: String!
    $name: String!
    $clusterType: String
    $userIds: [String!]!
    $subCluster: [SubClusterInput!]!
  ) {
    createEventCluster(
      data: {
        eventId: $eventId
        name: $name
        clusterType: $clusterType
        userIds: $userIds
        subCluster: $subCluster
      }
    )
  }
`;

export const UPDATE_EVENT_CUSTOM_CLUSTER = gql`
  mutation updateEventCustomCluster(
    $eventId: String!
    $crmClusterId: String!
    $name: String!
    $clusterType: String
    $users: [String!]!
    $subCluster: [SubClusterInput!]!
  ) {
    updateEventCustomCluster(
      data: {
        eventId: $eventId
        crmClusterId: $crmClusterId
        name: $name
        clusterType: $clusterType
        users: $users
        subCluster: $subCluster
      }
    )
  }
`;

export const UPDATE_TEAM = gql`
  mutation UpdateTeam($data: UpdateTeamInput!) {
    updateTeam(data: $data)
  }
`;

export const DELETE_TEAM = gql`
  mutation DeleteTeam($data: DeleteTeamInput!) {
    deleteTeam(data: $data)
  }
`;

// ============================================
// Training Schedule Mutations
// ============================================

export const CREATE_TRAINING_SCHEDULE = gql`
  mutation CreateTrainingSchedule($data: CreateTrainingScheduleInput!) {
    createTrainingSchedule(data: $data)
  }
`;

export const UPDATE_TRAINING_SCHEDULE = gql`
  mutation UpdateTrainingSchedule($data: UpdateTrainingScheduleInput!) {
    updateTrainingSchedule(data: $data)
  }
`;

export const DELETE_TRAINING_SCHEDULE = gql`
  mutation DeleteTrainingSchedule($data: DeleteTrainingScheduleInput!) {
    deleteTrainingSchedule(data: $data)
  }
`;

// ===========================================
// CREATE_PLATFORM_EVENT_SIZE mutations
// ===========================================

export const CREATE_PLATFORM_EVENT_SIZE = gql`
  mutation createPlatformEventSize(
    $platformEventID: String!
    $name: String!
    $gender: [String!]
    $colour: [String!]
    $productCategory: [String!]
    $electronicsCategory: [String!]
    $electronicsType: [String!]
    $homeGardenCategory: [String!]
    $petSuppliesCategory: [String!]
    $toysChildrenBabyCategory: [String!]
    $toysGamesType: [String!]
    $clothesCategory: [String!]
    $sportsOutdoorsCategory: [String!]
    $sportsOutdoorsFeature: [String!]
    $foodGroceryCategory: [String!]
    $healthBeautyCategory: [String!]
    $carMotorbikeCategory: [String!]
    $businessIndustryScienceCategory: [String!]
    $filmsTvMusicGamesCategory: [String!]
    $booksCategory: [String!]
    $diyCategory: [String!]
    $toolType: [String!]
    $heatingPlumbingType: [String!]
    $electricalLightingType: [String!]
    $bathroomKitchensType: [String!]
    $outdoorGardeningType: [String!]
    $screwsNailsFixingsType: [String!]
    $securityIronmongeryType: [String!]
    $buildingDoorsType: [String!]
    $safetyWorkwearType: [String!]
    $sealantsAdhesivesType: [String!]
    $autoCleaningType: [String!]
    $paintingDecorating: [String!]
    $clothingSize: [String!]
    $shoeSizes: [String!]
    $stockQuantity: String
    $stockPrice: String
    $saleTax: String
    $priceIncTax: String
    $stockId: String
    $stockThreshold: String
  ) {
    createPlatformEventSize(
      data: {
        platformEventID: $platformEventID
        name: $name
        gender: $gender
        colour: $colour
        productCategory: $productCategory
        electronicsCategory: $electronicsCategory
        electronicsType: $electronicsType
        homeGardenCategory: $homeGardenCategory
        petSuppliesCategory: $petSuppliesCategory
        toysChildrenBabyCategory: $toysChildrenBabyCategory
        toysGamesType: $toysGamesType
        clothesCategory: $clothesCategory
        sportsOutdoorsCategory: $sportsOutdoorsCategory
        sportsOutdoorsFeature: $sportsOutdoorsFeature
        foodGroceryCategory: $foodGroceryCategory
        healthBeautyCategory: $healthBeautyCategory
        carMotorbikeCategory: $carMotorbikeCategory
        businessIndustryScienceCategory: $businessIndustryScienceCategory
        filmsTvMusicGamesCategory: $filmsTvMusicGamesCategory
        booksCategory: $booksCategory
        diyCategory: $diyCategory
        toolType: $toolType
        heatingPlumbingType: $heatingPlumbingType
        electricalLightingType: $electricalLightingType
        bathroomKitchensType: $bathroomKitchensType
        outdoorGardeningType: $outdoorGardeningType
        screwsNailsFixingsType: $screwsNailsFixingsType
        securityIronmongeryType: $securityIronmongeryType
        buildingDoorsType: $buildingDoorsType
        safetyWorkwearType: $safetyWorkwearType
        sealantsAdhesivesType: $sealantsAdhesivesType
        autoCleaningType: $autoCleaningType
        paintingDecorating: $paintingDecorating
        clothingSize: $clothingSize
        shoeSizes: $shoeSizes
        stockQuantity: $stockQuantity
        stockPrice: $stockPrice
        saleTax: $saleTax
        priceIncTax: $priceIncTax
        stockId: $stockId
        stockThreshold: $stockThreshold
      }
    )
  }
`;

export const UPDATE_PLATFORM_EVENT_SIZE = gql`
  mutation updatePlatformEventSize(
    $id: String!
    $name: String
    $gender: [String!]
    $colour: [String!]
    $productCategory: [String!]
    $electronicsCategory: [String!]
    $electronicsType: [String!]
    $homeGardenCategory: [String!]
    $petSuppliesCategory: [String!]
    $toysChildrenBabyCategory: [String!]
    $toysGamesType: [String!]
    $clothesCategory: [String!]
    $sportsOutdoorsCategory: [String!]
    $sportsOutdoorsFeature: [String!]
    $foodGroceryCategory: [String!]
    $healthBeautyCategory: [String!]
    $carMotorbikeCategory: [String!]
    $businessIndustryScienceCategory: [String!]
    $filmsTvMusicGamesCategory: [String!]
    $booksCategory: [String!]
    $diyCategory: [String!]
    $toolType: [String!]
    $heatingPlumbingType: [String!]
    $electricalLightingType: [String!]
    $bathroomKitchensType: [String!]
    $outdoorGardeningType: [String!]
    $screwsNailsFixingsType: [String!]
    $securityIronmongeryType: [String!]
    $buildingDoorsType: [String!]
    $safetyWorkwearType: [String!]
    $sealantsAdhesivesType: [String!]
    $autoCleaningType: [String!]
    $paintingDecorating: [String!]
    $clothingSize: [String!]
    $shoeSizes: [String!]
    $stockQuantity: String
    $stockPrice: String
    $saleTax: String
    $priceIncTax: String
    $stockId: String
    $stockThreshold: String
  ) {
    updatePlatformEventSize(
      data: {
        id: $id
        name: $name
        gender: $gender
        colour: $colour
        productCategory: $productCategory
        electronicsCategory: $electronicsCategory
        electronicsType: $electronicsType
        homeGardenCategory: $homeGardenCategory
        petSuppliesCategory: $petSuppliesCategory
        toysChildrenBabyCategory: $toysChildrenBabyCategory
        toysGamesType: $toysGamesType
        clothesCategory: $clothesCategory
        sportsOutdoorsCategory: $sportsOutdoorsCategory
        sportsOutdoorsFeature: $sportsOutdoorsFeature
        foodGroceryCategory: $foodGroceryCategory
        healthBeautyCategory: $healthBeautyCategory
        carMotorbikeCategory: $carMotorbikeCategory
        businessIndustryScienceCategory: $businessIndustryScienceCategory
        filmsTvMusicGamesCategory: $filmsTvMusicGamesCategory
        booksCategory: $booksCategory
        diyCategory: $diyCategory
        toolType: $toolType
        heatingPlumbingType: $heatingPlumbingType
        electricalLightingType: $electricalLightingType
        bathroomKitchensType: $bathroomKitchensType
        outdoorGardeningType: $outdoorGardeningType
        screwsNailsFixingsType: $screwsNailsFixingsType
        securityIronmongeryType: $securityIronmongeryType
        buildingDoorsType: $buildingDoorsType
        safetyWorkwearType: $safetyWorkwearType
        sealantsAdhesivesType: $sealantsAdhesivesType
        autoCleaningType: $autoCleaningType
        paintingDecorating: $paintingDecorating
        clothingSize: $clothingSize
        shoeSizes: $shoeSizes
        stockQuantity: $stockQuantity
        stockPrice: $stockPrice
        saleTax: $saleTax
        priceIncTax: $priceIncTax
        stockId: $stockId
        stockThreshold: $stockThreshold
      }
    )
  }
`;

export const UPLOAD_PLATFORM_EVENT_SIZES = gql`
  mutation uploadPlatformEventSizes($data: UploadPlatformEventSizesInput!) {
    uploadPlatformEventSizes(data: $data)
  }
`;

export const DELETE_PLATFORM_EVENT_SIZE = gql`
  mutation deletePlatformEventSize($id: String!) {
    deletePlatformEventSize(data: { id: $id })
  }
`;

export const UPDATE_SQUAD_BUILDER_SETTINGS = gql`
  mutation UpdateSquadBuilderSettings($data: UpdateSquadBuilderSettingsInput!) {
    updateSquadBuilderSettings(data: $data)
  }
`;

export const CREATE_PLATFORM_EVENT_VENUE = gql`
  mutation createPlatformEventVenue(
    $name: String!
    $maxAttendees: Int!
    $platformEventID: String!
    $type: EventVenueType!
    $link: String!
    $defaultSlotTime: Int
    $venueAddress: String
  ) {
    createPlatformEventVenue(
      data: {
        platformEventID: $platformEventID
        name: $name
        maxAttendees: $maxAttendees
        defaultSlotTime: $defaultSlotTime
        link: $link
        type: $type
        venueAddress: $venueAddress
      }
    )
  }
`;

export const UPDATE_PLATFORM_EVENT_VENUE = gql`
  mutation updatePlatformEventVenue(
    $name: String!
    $maxAttendees: Int!
    $maxSlots: Int
    $id: String!
    $type: EventVenueType!
    $defaultSlotTime: Int
    $link: String
    $venueAddress: String
  ) {
    updatePlatformEventVenue(
      data: {
        id: $id
        name: $name
        maxAttendees: $maxAttendees
        maxSlots: $maxSlots
        defaultSlotTime: $defaultSlotTime
        type: $type
        link: $link
        venueAddress: $venueAddress
      }
    )
  }
`;

export const DELETE_PLATFORM_EVENT_VENUE = gql`
  mutation deletePlatformEventVenue($id: String!) {
    deletePlatformEventVenue(data: { id: $id })
  }
`;

export const ASSIGN_PLAYER_TO_TEAM = gql`
  mutation AssignPlayerToTeam($data: AssignPlayerToTeamInput!) {
    assignPlayerToTeam(data: $data)
  }
`;

export const REMOVE_PLAYER_FROM_TEAM = gql`
  mutation RemovePlayerFromTeam($data: RemovePlayerFromTeamInput!) {
    removePlayerFromTeam(data: $data)
  }
`;

export const UPDATE_SQUAD_BUILDER_DATA = gql`
  mutation UpdateSquadBuilderData($data: UpdateSquadBuilderDataInput!) {
    updateSquadBuilderData(data: $data)
  }
`;

export const SET_PLAYER_KIT_NUMBER = gql`
  mutation SetPlayerKitNumber(
    $eventId: String!
    $userId: String!
    $kitNumber: Float
  ) {
    setPlayerKitNumber(
      eventId: $eventId
      userId: $userId
      kitNumber: $kitNumber
    )
  }
`;

export const SUBMIT_TEAM_REGISTRATION = gql`
  mutation SubmitTeamRegistration($data: SubmitTeamRegistrationInput!) {
    submitTeamRegistration(data: $data)
  }
`;

export const CREATE_EVENT_INVITATION = gql`
  mutation createEventInvitation($id: String!, $inviteeEmails: [String!]!) {
    createEventInvitation(
      data: {
        eventID: $id
        eventType: PLATFORM_EVENT
        inviteeEmails: $inviteeEmails
      }
    )
  }
`;

export const UPDATE_TRIALIST_STATUS = gql`
  mutation UpdateAttendeeStatus($data: UpdateAttendeeStatusInput!) {
    updateAttendeeStatus(data: $data)
  }
`;

export const UPDATE_CLUB_REVIEW_STATUS = gql`
  mutation UpdateClubReviewStatus($data: UpdateClubReviewStatusInput!) {
    updateClubReviewStatus(data: $data)
  }
`;

export const ASSIGN_USERS_TO_SUBCLUSTERS = gql`
  mutation assignUsersToSubclusters($data: AssignUsersToSubclustersInput!) {
    assignUsersToSubclusters(data: $data)
  }
`;

export const REMOVE_CALENDAR_INVITATION = gql`
  mutation removeCalendarInvitation($invitationId: String!) {
    removeCalendarInvitation(data: { invitationId: $invitationId })
  }
`;

export const MAKE_REFUND_TRANSACTION = gql`
  mutation refundTransaction($txnId: String!, $eventItem: Boolean) {
    refundTransaction(txnId: $txnId, eventItem: $eventItem)
  }
`;

export const UPDATE_USER_PROFILE = gql`
  mutation updateUserProfile(
    $userId: String
    $gender: String!
    $dob: String
    $passportNumber: String
    $nationalSecurityNumber: String
    $address: CreateGenericAddressInput
    $deliveryAddress: CreateGenericAddressInput
    $avatar: String
    $profiles: [UserProfileInput!]
    $secondaryProfilePic: String
    $sportsProfiles: [SportsProfileInput!]
    $sportsProfilePic: String
    $sportsProfileId: String
    $selectedSport: String
  ) {
    updateUserProfile(
      data: {
        userId: $userId
        gender: $gender
        dob: $dob
        passportNumber: $passportNumber
        nationalSecurityNumber: $nationalSecurityNumber
        address: $address
        deliveryAddress: $deliveryAddress
        avatar: $avatar
        profiles: $profiles
        secondaryProfilePic: $secondaryProfilePic
        sportsProfiles: $sportsProfiles
        sportsProfilePic: $sportsProfilePic
        sportsProfileId: $sportsProfileId
        selectedSport: $selectedSport
      }
    )
  }
`;

export const SCAN_EVENT_QR_CODE = gql`
  mutation ScanEventQrCode(
    $userId: String!
    $eventId: String
    $scanToken: String!
  ) {
    scanEventQrCode(userId: $userId, eventId: $eventId, scanToken: $scanToken) {
      success
      message
      scan {
        id
        scannedAt
      }
    }
  }
`;

// Mutation to update the QR preferences (QR Entry) for a specific event.
export const UPDATE_EVENT_QR_PREFERENCES = gql`
  mutation UpdateEventQrPreferences(
    $eventId: ID!
    $qrPreferences: QrPreferencesInput!
  ) {
    updateEventQrPreferences(eventId: $eventId, qrPreferences: $qrPreferences) {
      first_checked
      last_checked
      avatar_checked
      company_checked
      job_title_checked
      age_checked
      member_id_checked
      location_checked
      gender_checked
      email_checked
      mobile_checked
      phone_checked
      dob_checked
      salutation_checked
      region_checked
      country_checked
      city_checked
      postcode_checked
      address_checked
      addressTwo_checked
      bio_checked
      categorisedKeywords_checked
      clusterKeywords_checked
      keywords_checked
      locale_checked
      facebook_checked
      instagram_checked
      linkedIn_checked
      twitter_checked
      weChat_checked
      weibo_checked
      qq_checked
      skype_checked
      socialLine_checked
      nationalSecurityNumber_checked
      passportNumber_checked
    }
  }
`;

// Mutation to update the scanned QR preferences (QR scanned) for a specific event.
export const UPDATE_SCANNED_EVENT_QR_PREFERENCES = gql`
  mutation UpdateScannedEventQrPreferences(
    $eventId: ID!
    $qrPreferences: QrPreferencesInput!
  ) {
    updateScannedEventQrPreferences(
      eventId: $eventId
      qrPreferences: $qrPreferences
    ) {
      first_checked
      last_checked
      avatar_checked
      company_checked
      job_title_checked
      age_checked
      member_id_checked
      location_checked
      gender_checked
      email_checked
      mobile_checked
      phone_checked
      dob_checked
      salutation_checked
      region_checked
      country_checked
      city_checked
      postcode_checked
      address_checked
      addressTwo_checked
      bio_checked
      categorisedKeywords_checked
      clusterKeywords_checked
      keywords_checked
      locale_checked
      facebook_checked
      instagram_checked
      linkedIn_checked
      twitter_checked
      weChat_checked
      weibo_checked
      qq_checked
      skype_checked
      socialLine_checked
      nationalSecurityNumber_checked
      passportNumber_checked
    }
  }
`;
export const SET_CLUSTER_PAGE_RESTRICTIONS = gql`
  mutation setClusterPageRestrictions($eventId: String!, $linkedPages: String!) {
    setClusterPageRestrictions(
      data: { eventId: $eventId, linkedPages: $linkedPages }
    )
  }
`;
